import { useState, useCallback, useMemo } from 'react';

export function useCaptcha({
    initialEnabled = false,
    width = 200,
    height = 45,
}: {
    initialEnabled?: boolean;
    width?: number;
    height?: number;
} = {}) {
    const [enabled, setEnabled] = useState(initialEnabled);
    const [attempts, setAttempts] = useState(0);

    const id = useMemo(() => {
        let captchaId = '';
        const idChars = 'qwertyuiopasdfghjklzxcvbnm1234567890';
        for (let i = 0; i < 32; i++) {
            captchaId = captchaId + idChars[Math.floor(Math.random() * idChars.length)];
        }
        return captchaId;
    }, []);

    const imageSrc = enabled ? `/captcha-image/${id}?w=${width}&h=${height}&v=${attempts}` : '';

    const enable = useCallback(() => {
        setEnabled(true);
        setAttempts((c) => c + 1);
    }, []);

    const refresh = useCallback(() => {
        setAttempts((c) => c + 1);
    }, []);

    return {
        id,
        imageSrc,
        attempts,
        refresh,
        enable,
    };
}
